import { FC } from 'react'
import { classes, style, stylesheet } from 'typestyle'

import { TOOLBAR_HEIGHT } from '../../../components/app-layout/app-layout.constants'
import { Box } from '../../../components/box/box.component'
import { useTheme } from '../../../components/theme'

export const NavTopContent: FC<{ children?: any; shadow?: boolean }> = props => {
  const { children } = props
  const [currentTheme] = useTheme()

  return (
    <Box
      baseline="surface"
      className={classes(
        STYLES.containerTopContent,
        style({ borderBottom: `1px solid ${currentTheme.boxes.border.medium}` }),
      )}
      minHeight={TOOLBAR_HEIGHT}
      row
      relative
      alignCenterY
    >
      {children}
    </Box>
  )
}

export const NavContent: FC<{ children?: any; style?: any }> = props => {
  const { children } = props
  const [currentTheme] = useTheme()

  return (
    <Box
      baseline="none"
      className={classes(
        STYLES.containerContent,
        style({ borderRight: `1px solid ${currentTheme.boxes.border.medium}` }),
      )}
      style={props.style}
      flex
      row
      spaceBetween
    >
      {children}
    </Box>
  )
}

export const NavBottomContent: FC<{ children?: any }> = props => {
  const { children } = props
  return (
    <Box baseline="surface" className={STYLES.containerBottomContent}>
      {children}
    </Box>
  )
}

const STYLES = stylesheet({
  containerContent: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
    width: '100%',
    paddingTop: 1,
    $nest: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  containerTopContent: {
    display: 'inline-block',
    width: '100%',
    height: 'fit-content',
    zIndex: 2,
    position: 'relative',
    $nest: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  containerBottomContent: {
    display: 'inline-block',
    width: '100%',
    height: 'fit-content',
    position: 'relative',
    zIndex: 5,
    $nest: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
})
